query MailerConfigsList(
  $page: Int = 0
  $rowsPerPage: Int = 10
  $filter: MailerConfigsFilterInput
) {
  mailerConfigs(page: $page, rowsPerPage: $rowsPerPage, filter: $filter) {
    nodes {
      id
      title
      from
      siteUrl
      siteName
      siteEmail
      logo {
        id
        url
      }
      createdAt
      updatedAt
      deletedAt
      deleted
    }
    count
  }
}
